export default __webpack_public_path__ + "media/images/diamond-022bc379e46f8a53664e47f0aff4447f.svg";